import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiLogIn } from 'react-icons/fi';

// ** MUI Components
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

import illustration from '../../assets/location-concept-light.svg';
import api from '../../services/api';
import './styles.css';

export default function UserNew() {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPass, setConfirmPass] = useState('');

  function checkAuth() {
    const isLogged = localStorage.getItem('token');
    if (!isLogged) navigate('/');
  }

  useEffect(() => {
    checkAuth();
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();

    const data = {
      name,
      email,
      password,
    };

    try {
      if (confirmPass !== password) {
        alert('Senhas não são iguais!');
        return;
      }

      await api.post('/users', data);

      navigate('/users');
    } catch (err) {
      console.error(err);
      if (err.response.status === 500) {
        alert(
          'Falha ao cadastrar usuário, tente novamente mais tarde!',
        );
      } else if (err.response.status === 400) {
        alert('Senha inválida, a senha precisa ter:\n- Pelo menos uma letra maiúscula e uma minúscula;\n- Pelo menos um número e um caractere especial.');
      }
    }
  };

  return (
    <div className="register-container">
      <main className="content">
        <section>
          <img src={illustration} alt="Illustration" />
        </section>
        <form onSubmit={handleRegister}>
          <h1>Cadastro</h1>
          <div className="icons" />
          <FormControl
            fullWidth
            sx={{
              my: 1,
            }}
          >
            <TextField
              label="Nome"
              value={name}
              type="text"
              placeholder="Digite seu nome"
              onChange={(e) => setName(e.target.value)}
              required
            />
          </FormControl>
          <FormControl
            fullWidth
            sx={{
              my: 1,
            }}
          >
            <TextField
              label="E-mail"
              value={email}
              type="email"
              placeholder="Digite seu e-mail"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </FormControl>
          <FormControl
            fullWidth
            sx={{
              my: 1,
            }}
          >
            <TextField
              label="Senha"
              value={password}
              type="password"
              placeholder="Digite uma senha"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </FormControl>
          <FormControl
            fullWidth
            sx={{
              my: 1,
            }}
          >
            <TextField
              label="Confirmar senha"
              type="password"
              value={confirmPass}
              placeholder="Confirme a senha"
              onChange={(e) => setConfirmPass(e.target.value)}
              required
            />
          </FormControl>
          <Button
            sx={{
              mt: 1,
              width: '100%',
              height: 60,
            }}
            type="submit"
            size="large"
            variant="contained"
          >
            Confirmar
          </Button>
          <div className="back-button">
            <Link className="back-link" to="/users">
              <FiLogIn size={20} color="#414141" />
              Voltar para home
            </Link>
          </div>
        </form>
      </main>
    </div>
  );
}
